module.exports = __webpack_public_path__ + "06_short_beige.b930bec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/06_short_beige.png
// module id = C/7P
// module chunks = 0